import React, { useState } from "react";
import { NavLink } from "react-router";

function Navbar({ event }) {
  const [isOpen, setIsOpen] = useState(false);

  const navList = [
    {
      label: "Home",
      href: "/",
      id: "home",
    },
    {
      label: "Agenda",
      href: "/agenda",
      id: "agenda",
    },
    {
      label: "Speakers",
      href: "/speakers",
      id: "speakers",
    },
    {
      label: "Gallery",
      href: "/gallery",
      id: "gallery",
    },
    {
      label: "Contact",
      href: "/contact",
      id: "contact",
    },
    {
      label: "Feedback",
      href: "/feedback",
      id: "feedback",
    },
    {
      label: "Sign In",
      href: "/signin",
      id: "signin",
    },
  ];

  return (
    <div>
      <header className="bg-gray-50 ">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            <div className="md:flex md:items-center md:gap-12">
              <a className="block text-teal-600" href="/">
                <span className="sr-only">Home</span>
                <img
                  className="h-12 w-auto"
                  alt="Kebs Logo"
                  src="/Assets/kebs_logo.png"
                />
              </a>
            </div>

            <div className="hidden md:block">
              <nav aria-label="Global">
                <ul className="flex items-center gap-6 text-sm">
                  {navList.map((item) => (
                    <li key={item.id}>
                      <NavLink
                        to={`/events/${event.event_slug}${item.href}`}
                        className={({ isActive }) =>
                          `${isActive ? "text-blue-700" : "text-gray-500"} transition hover:text-blue-700`
                        }
                      >
                        {item.label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>

            <div className="flex items-center gap-4">
              <div className="sm:flex sm:gap-4">
                <a
                  className="rounded-md px-5 py-2.5 text-sm font-medium  bg-[#0166b1] text-white hover:text-white/75"
                  href={`/events/${event.event_slug}/registration`}
                >
                  Register
                </a>

                {/* <div className="hidden sm:flex">
                  <a
                    className="rounded-md bg-teal-600 px-5 py-2.5 text-sm font-medium text-white shadow-sm dark:hover:bg-teal-500"
                    href="/"
                  >
                    Login
                  </a>
                </div> */}
              </div>

              <div className="block md:hidden">
                <button
                  onClick={() => setIsOpen(!isOpen)}
                  className="rounded-sm bg-gray-100 p-2 text-gray-600 transition hover:text-gray-600/75 dark:bg-gray-800 dark:text-white dark:hover:text-white/75"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="size-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M4 6h16M4 12h16M4 18h16"
                    ></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>
      {isOpen && (
        <div
          role="menu"
          className="md:hidden bg-white dark:bg-gray-900 px-4 py-4 shadow-lg dark:text-white"
        >
          <ul className="flex flex-col gap-4 text-sm">
            {navList.map((item) => (
              <li key={item.id}>
                <NavLink
                  to={`/events/${event.event_slug}${item.href}`}
                  className="block px-3 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 hover:text-gray-900 dark:text-gray-200 dark:hover:bg-gray-700 dark:hover:text-white"
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default Navbar;
